import React, { useRef } from 'react';
import { Calendar, MessageSquare, ShieldCheck, FileText } from 'lucide-react';
import { motion, useInView } from 'framer-motion';
export function MechanismSection() {
  const tools = [{
    icon: <Calendar className="h-8 w-8 text-neutral-900" data-id="element-105" />,
    title: 'Day-by-Day Plan',
    description: 'So you do the right things first. We sequence your first 14 days so you never have to guess "what\'s next?".'
  }, {
    icon: <MessageSquare className="h-8 w-8 text-neutral-900" data-id="element-106" />,
    title: 'Pressure-Relief Scripts',
    description: 'Exact phrases to stop pressure and force clarity. Know exactly what to say to landlords, agents, and officials.'
  }, {
    icon: <ShieldCheck className="h-8 w-8 text-neutral-900" data-id="element-107" />,
    title: 'Trap-Scanners',
    description: 'Checklists to spot bad deals fast. We highlight the red flags that locals know but newcomers miss.'
  }, {
    icon: <FileText className="h-8 w-8 text-neutral-900" data-id="element-108" />,
    title: 'Proof Library Setup',
    description: 'A system to organize your documents so you can defend yourself and win disputes automatically.'
  }];
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section className="py-24 px-4 sm:px-6 bg-neutral-900 text-white" data-id="element-109">
      <div className="max-w-5xl mx-auto" ref={ref} data-id="element-110">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-111">
          <span className="text-amber-400 font-bold tracking-wider uppercase text-sm mb-4 block" data-id="element-112">
            Introducing
          </span>
          <h2 className="text-4xl md:text-5xl font-bold mb-6 font-serif" data-id="element-113">
            The 14-Day Settle-In OS
          </h2>
          <p className="text-xl text-neutral-300 max-w-2xl mx-auto" data-id="element-114">
            A universal “operating system” you can use in any country. In 14
            days, you’ll have your essentials set up in the correct
            order—without signing your life away under pressure.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-115">
          {tools.map((tool, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 30
        }} transition={{
          duration: 0.6,
          delay: index * 0.15 + 0.2
        }} className="bg-neutral-800/50 border border-neutral-700 p-8 rounded-xl hover:bg-neutral-800 transition-colors" data-id="element-116">
              <div className="bg-[#FAF8F6] p-3 rounded-lg w-fit mb-6" data-id="element-117">
                {tool.icon}
              </div>
              <h3 className="text-2xl font-bold mb-3 font-serif text-white" data-id="element-118">
                {tool.title}
              </h3>
              <p className="text-neutral-300 leading-relaxed" data-id="element-119">
                {tool.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}